// ============== START : Native side cart toggle (native vs Rebuy) ==============
// Controlled by the theme setting `enable_native_cart`.
//   ON  -> native ajax-cart drawer replaces Rebuy; Rebuy SmartCart is suppressed.
//   OFF -> nothing is patched; Rebuy behaves exactly as before (clean revert).
(function () {
  var USE_NATIVE = true;
  if (!USE_NATIVE) return;

  // --- 1) Repoint the Alpine cart store to the native drawer ---
  // (body scroll lock is handled by <body :class="cartIsOpen ? 'overflow-hidden' : ''"> in theme.liquid)
  function patchCartStore() {
    if (!window.Alpine || typeof Alpine.store !== 'function') return false;
    var cart = Alpine.store('cart');
    if (!cart) return false;
    cart.openMiniCart = function () { this.cartIsOpen = true; };
    cart.closeMiniCart = function () { this.cartIsOpen = false; };

    if (!cart.__myoChangeWrapped) {
      cart.__myoChangeWrapped = true;
      ['add', 'change'].forEach(function (m) {
        if (typeof cart[m] !== 'function') return;
        var orig = cart[m].bind(cart);
        cart[m] = function () {
          var r = orig.apply(this, arguments);
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('myo:cart.change'));
          }, 350);
          return r;
        };
      });
    }
    return true;
  }
  if (!patchCartStore()) {
    document.addEventListener('alpine:init', patchCartStore);
    document.addEventListener('alpine:initialized', patchCartStore);
    var tries = 0;
    var poll = setInterval(function () {
      if (patchCartStore() || ++tries > 100) clearInterval(poll);
    }, 50);
  }

  // --- 2) Suppress Rebuy SmartCart so only the native drawer ever opens ---
  function hideRebuy() {
    if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === 'function') {
      try { Rebuy.SmartCart.hide(); } catch (e) {}
    }
  }
  function neutraliseRebuy() {
    if (!window.Rebuy || !Rebuy.SmartCart) return false;
    if (!Rebuy.SmartCart.__myoNeutralised) {
      Rebuy.SmartCart.__myoNeutralised = true;
      try { Rebuy.SmartCart.show = function () {}; } catch (e) {}   // block auto-open
    }
    hideRebuy();
    return true;
  }
  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.show', 'rebuy:smartcart.show']
    .forEach(function (ev) { document.addEventListener(ev, hideRebuy); });
  if (!neutraliseRebuy()) {
    var rtries = 0;
    var rpoll = setInterval(function () {
      if (neutraliseRebuy() || ++rtries > 200) clearInterval(rpoll);
    }, 100);
  }
})();
// ============== END : Native side cart toggle ==============


(function () {
  var USE_NATIVE = true;
  if (!USE_NATIVE) return;

  var ROOT = '.ajax-cart__discount';

  function cartStore() {
    return (window.Alpine && typeof Alpine.store === 'function') ? Alpine.store('cart') : null;
  }

  function currentCodes() {
    return Array.prototype.slice.call(document.querySelectorAll('.ajax-cart__discount-row'))
      .map(function (el) { return (el.getAttribute('data-code') || '').trim(); })
      .filter(Boolean);
  }

  function errorBox() { return document.querySelector('.ajax-cart__discount-error'); }
  function showError(msg) {
    var box = errorBox();
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }
  function clearError() {
    var box = errorBox();
    if (box) { box.textContent = ''; box.hidden = true; }
  }

  function setBusy(busy) {
    var btn = document.querySelector('.ajax-cart__discount-apply');
    if (!btn) return;
    if (busy) {
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      btn.textContent = 'Applying…';
      btn.disabled = true;
    } else {
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
      btn.disabled = false;
    }
  }

  function sameCode(a, b) {
    return (a || '').toLowerCase() === (b || '').toLowerCase();
  }

  function codeIsApplied(html, code) {
    if (!html) return false;
    var attrs = html.match(/data-code="[^"]*"/gi) || [];
    return attrs.some(function (a) { return sameCode(a.slice(11, -1), code); });
  }

  function updateDiscount(codesToKeep, enteredCode) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codesToKeep.join(','), sections: ['ajax-cart'] })
    }).then(function (res) {
      return res.json().then(function (data) { return { status: res.status, data: data }; });
    }).then(function (r) {
      var data = r.data || {};
      var html = data.sections && data.sections['ajax-cart'];
      if (r.status !== 200) { showError('This code is not valid.'); return; }
      if (enteredCode && !codeIsApplied(html, enteredCode)) {
        showError('This code is not valid.');
        return;
      }
      var store = cartStore();
      if (store && typeof store.renderFromResponse === 'function' && html) {
        store.renderFromResponse(html);
      }
    }).catch(function (e) {
      console.error('[native-cart] discount error', e);
      showError('Something went wrong. Please try again.');
    });
  }

  function applyFromInput(input) {
    var code = (input.value || '').trim();
    clearError();
    if (!code) { input.focus(); return; }
    var keep = currentCodes().filter(function (c) { return !sameCode(c, code); });
    keep.push(code);
    setBusy(true);
    updateDiscount(keep, code).then(function () { setBusy(false); }, function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var apply = e.target.closest('.ajax-cart__discount-apply');
    if (apply) {
      var wrap = apply.closest(ROOT);
      var input = wrap && wrap.querySelector('.ajax-cart__discount-input');
      if (input) applyFromInput(input);
      return;
    }
    var remove = e.target.closest('.ajax-cart__discount-remove');
    if (remove) {
      var tag = remove.closest('.ajax-cart__discount-row');
      var code = tag && (tag.getAttribute('data-code') || '').trim();
      clearError();
      var keep = currentCodes().filter(function (c) { return !sameCode(c, code); });
      updateDiscount(keep, null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var input = e.target.closest('.ajax-cart__discount-input');
    if (!input) return;
    e.preventDefault();
    applyFromInput(input);
  });
})();


const intervalId = setInterval(() => {
  const widget = document.querySelector('.product-information_section-inner .rebuy-bundle');
  if (widget) {  

  // ======================== START :  Heading and div append Js ================================

    const imagesContainer = document.querySelector('.rebuy-bundle__images');
    const actionsDiv = document.querySelector('.rebuy-bundle__actions');

    if (imagesContainer && actionsDiv) {
      imagesContainer.appendChild(actionsDiv);
    }

    if (actionsDiv) {
      // Create new heading div
      const headingDiv = document.createElement('div');
      headingDiv.classList.add('rebuy-bundle-heading');

      const originalHeading = document.querySelector('.product-information_section-inner h1');
      headingDiv.textContent = originalHeading ? originalHeading.textContent : "Default Heading";

      // Append headingDiv inside actionsDiv
      actionsDiv.appendChild(headingDiv);
    }

  // ======================== END :  Heading and div append Js ================================


  // ======================== START :  Save Price Js ================================

    // Dynamic price save calculation & insertion
    const priceValue = document.querySelector('.rebuy-bundle__actions-price-value');
    if (priceValue && !priceValue.querySelector('.rebuy-money.save-price')) {
      const saleSpan = priceValue.querySelector('.rebuy-money.sale span:not(.sr-only)');
      const originalSpan = priceValue.querySelector('.rebuy-money.compare-at span:not(.sr-only)');

      if (saleSpan && originalSpan) {
        const saleText = saleSpan.textContent.trim();
        const originalText = originalSpan.textContent.trim();

        const currency = saleText[0];
        const salePrice = parseFloat(saleText.slice(1).replace(/,/g, ''));
        const originalPrice = parseFloat(originalText.slice(1).replace(/,/g, ''));

        if (!isNaN(salePrice) && !isNaN(originalPrice) && originalPrice > salePrice) {
          const saveAmount = (originalPrice - salePrice).toFixed(2);

          const saveSpan = document.createElement('span');
          saveSpan.classList.add('rebuy-money', 'save-price');
          saveSpan.textContent = `save: ${currency}${saveAmount}`;

          priceValue.appendChild(saveSpan);
        }
      }
    }

    // ======================== END :  Save Price Js ================================

    // ======================== START :  Drop Down  Js ================================

    const firstItem = document.querySelector('.rebuy-bundle__items');
    if (firstItem) {
      const newDiv = document.createElement('div');
      newDiv.classList.add('rebuy-include-dropdown');

      const textNode = document.createTextNode("What’s included: ");
      newDiv.appendChild(textNode);

      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", "17");
      svg.setAttribute("height", "17");
      svg.setAttribute("viewBox", "0 0 17 17");
      svg.setAttribute("fill", "none");
      svg.classList.add('rebuy-icon');

      const path = document.createElementNS(svgNS, "path");
      path.setAttribute("d", "M8.01995 8.01909L11.3198 11.3189L12.2626 10.3761L8.01995 6.13343L3.77734 10.3761L4.72015 11.3189L8.01995 8.01909Z");
      path.setAttribute("fill", "black");

      svg.appendChild(path);
      newDiv.appendChild(svg);

      firstItem.classList.add('active');

      newDiv.addEventListener('click', () => {
        firstItem.classList.toggle('active');
      });

      firstItem.prepend(newDiv);
    }

    // ======================== END :  Drop Down  Js ================================


    // ======================== START :Radio Butto Js ================================
    var addBtn = document.querySelector(".custom-product-add-btn");
    var formAddButton = document.querySelector(".product-form-submit-button #add-to-cart");
    const bundle = document.querySelector('.rebuy-bundle');
    // Skip if checkbox already exists
    if (bundle.querySelector('input.rebuy-bundle-radio')) return;

    // Create bundle checkbox
    const bundleCheckbox = document.createElement('input');
    bundleCheckbox.type = 'checkbox';
    bundleCheckbox.name = 'rebuy-bundle-selection';
    bundleCheckbox.classList.add('rebuy-bundle-radio');
    bundleCheckbox.value = `bundle-0`;
    bundleCheckbox.checked = true; // default checked

    // Insert checkbox at the start of the bundle
    bundle.prepend(bundleCheckbox);

    // Select all internal product checkboxes
    const productCheckboxes = bundle.querySelectorAll(
      '.rebuy-product-block .rebuy-product-checkbox .rebuy-checkbox-label input[type="checkbox"]'
    );

    // On page load, make all internal checkboxes checked
    productCheckboxes.forEach((cb) => (cb.checked = true));

    // Show/hide ATC buttons based on bundle checkbox on page load
    

    function toggleButtons(isBundleChecked) {
        if (!addBtn || !formAddButton) return;
        addBtn.style.display = isBundleChecked ? 'inline-flex' : 'none';
        formAddButton.style.display = isBundleChecked ? 'none' : 'inline-flex';
    }
    toggleButtons(bundleCheckbox.checked);
    // if (bundleCheckbox.checked) {
    //     addBtn.style.display = 'inline-flex';
    //     formAddButton.style.display = 'none';
    // } else {
    //     addBtn.style.display = 'none';
    //     formAddButton.style.display = 'inline-flex';
    // }

    // Toggle internal checkboxes when bundle checkbox is clicked
    bundleCheckbox.addEventListener('change', () => {
        const checked = bundleCheckbox.checked;
        productCheckboxes.forEach((cb) => {
          cb.checked = checked; // check all if bundle is checked, uncheck all if not
        });
        // Show/hide buttons
        toggleButtons(bundleCheckbox.checked);
        // if (checked) {
        //   addBtn.style.display = 'inline-flex';
        //   formAddButton.style.display = 'none';
        // } else {
        //   addBtn.style.display = 'none';
        //   formAddButton.style.display = 'inline-flex';
        // }
    });

  // ======================== END :Radio Butto Js ================================

    // ======================== START :Add to cart button Js ================================
    var rebuyWidget = document.querySelector(".product-information_section-inner .rebuy-widget");

    if (rebuyWidget && addBtn) {
      var priceEl = document.querySelector('.rebuy-bundle__actions-price-value .rebuy-money.sale span:nth-child(2)');
      var targetEl = document.querySelector('.custom-product-add-btn .rebuy-bundle-total-price');

      if (priceEl && targetEl) {
          var priceText = priceEl.textContent.trim(); 
          targetEl.textContent = `(${priceText})`; 
      }
      // Attach click event
      addBtn.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent default if needed
          var hiddenBtn = document.querySelector(".rebuy-bundle__actions-buttons .rebuy-button");
          if (hiddenBtn) {
              hiddenBtn.click(); // Trigger hidden button
          }
      });
    }
    // ======================== END :Add to cart button Js ================================

    clearInterval(intervalId);
  }
}, 1000);

// ========== START: Bundle builder page ======================/
document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector(".template-bundle-builder-page")){
        var interval = setInterval(function () {
            var ctaContainer = document.querySelector(".rebuy-bundle-builder__cta-container");
            var guaranteeSection = document.querySelector(".shipping-guarantee-section");

            if (ctaContainer && guaranteeSection) {
            ctaContainer.appendChild(guaranteeSection);
            clearInterval(interval);
            }
        }, 100);
    }
});
// ========== END: Bundle builder page ======================/
/*** BEGIN: Deliver and Assemble ***/
(function() {
const postcodesUrl = '//myomaster.com/cdn/shop/t/74/assets/excluded-build-post-codes.json?v=28302158384697379271776773712';

const DA_NativeCart = {
  _chain: Promise.resolve(),
  _store: function () {
    return (window.Alpine && typeof Alpine.store === 'function') ? Alpine.store('cart') : null;
  },
  _afterWrite: function (data) {
    try {
      var store = DA_NativeCart._store();
      var html = data && data.sections && data.sections['ajax-cart'];
      if (store && html && typeof store.renderFromResponse === 'function') store.renderFromResponse(html);
      if (store && typeof store.getCardItems === 'function') store.getCardItems();
    } catch (e) {}
    return data;
  },
  getItems: function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c && c.items) || []; })
      .catch(function () { return []; });
  },
  _enqueue: function (task) {
    DA_NativeCart._chain = DA_NativeCart._chain.then(task, task);
    return DA_NativeCart._chain;
  },
  addItem: function (variantId, quantity) {
    return DA_NativeCart._enqueue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: ['ajax-cart'] })
      }).then(function (r) { return r.json(); }).then(DA_NativeCart._afterWrite).then(function (data) {
        var store = DA_NativeCart._store();
        if (store && typeof store.openMiniCart === 'function') store.openMiniCart();
        return data;
      });
    });
  },
  setQuantity: function (key, quantity) {
    return DA_NativeCart._enqueue(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ['ajax-cart'] })
      }).then(function (r) { return r.json(); }).then(DA_NativeCart._afterWrite);
    });
  }
};

class DeliverAndAssemble extends HTMLElement {
  static mounted;

  constructor() {
    super();

    fetch(postcodesUrl)
        .then(resp => resp.json())
        .then(data => this.postcodes = data.codes);

  }

  // addMissingBuildProducts() {
  //   const items = Rebuy.Cart.getItems();
  //   const itemMap = new Map(items.map(item => [item.product_id, item]));
  //   const validMainIds = new Set(items.map(item => item.product_id));

  //   for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
  //       if (validMainIds.has(product_id) && !itemMap.has(build_product_id)) {
  //           Rebuy.Cart.addItem({id: build_product_variant, quantity: 1});
  //       }
  //   }
  // }
  async addMissingBuildProducts() {
    if (this._addingBuildProduct) return;
    this._addingBuildProduct = true;
    try {
      const items = await DA_NativeCart.getItems();
      const presentProductIds = new Set(items.map(item => item.product_id));

      for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
        if (presentProductIds.has(product_id) && !presentProductIds.has(build_product_id)) {
          await DA_NativeCart.addItem(build_product_variant, 1);
        }
      }
    } finally {
      this._addingBuildProduct = false;
    }
  }
  // addMissingBuildProducts() {
  //   const excludedBuildProducts = [55985881612665, 56190945132921]; // 🚫 excluded

  //   const items = Rebuy.Cart.getItems();
  //   const itemMap = new Map(items.map(item => [item.product_id, item]));
  //   const validMainIds = new Set(items.map(item => item.product_id));

  //   for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
  //     if (excludedBuildProducts.includes(build_product_id)) continue; // skip excluded

  //     if (validMainIds.has(product_id) && !itemMap.has(build_product_id)) {
  //       if (!this._addingBuildProduct) {
  //         this._addingBuildProduct = true;
  //         Rebuy.Cart.addItem({ id: build_product_variant, quantity: 1 }).then(() => {
  //           this._addingBuildProduct = false;
  //         });
  //       }
  //     }
  //   }
  // }

  async removeBuildProductsWithMissingMainProduct() {
    const items = await DA_NativeCart.getItems();
    const validMainIds = new Set(items.map(item => item.product_id));

    const comboMap2 = new Map();
    DeliverAndAssembleCombinations.forEach(c => {
      const ids = comboMap2.get(c.build_product_id) || [];
      ids.push(c.product_id);
      comboMap2.set(c.build_product_id, ids);
    });

    for (const item of [...items]) {
        const mainIds = comboMap2.get(item.product_id);

        if (mainIds && !mainIds.some(id => validMainIds.has(id))) {
            await DA_NativeCart.setQuantity(item.key, 0);
        }
    }
  }
  async removeAllBuildProducts() {
    const items = await DA_NativeCart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));

    for (const item of [...items]) {
        if (buildProductsIds.has(item.product_id))
            await DA_NativeCart.setQuantity(item.key, 0);
    }

    // ✅ Reset add flag so user can add again after removing
    this._addingBuildProduct = false;
  }

  // removeAllBuildProducts() {
  //   const excludedBuildProducts = [55985881612665, 56190945132921]; // 🚫 excluded

  //   const items = Rebuy.Cart.getItems();
  //   const buildProductsIds = new Set(
  //     DeliverAndAssembleCombinations
  //       .map(c => c.build_product_id)
  //       .filter(id => !excludedBuildProducts.includes(id)) // skip excluded
  //   );

  //   for (const item of [...items]) {
  //     if (buildProductsIds.has(item.product_id)) {
  //       Rebuy.Cart.removeItem(item);
  //     }
  //   }

  //   this._addingBuildProduct = false;
  // }


  async makeSureBuildProductIsOne() {
    const items = await DA_NativeCart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));

    for (const item of [...items]) {
        if (item.quantity > 1 && buildProductsIds.has(item.product_id))
            await DA_NativeCart.setQuantity(item.key, 1);
    }
  }

  checkPostCode() {
    const postcode = this.querySelector('.da-checker-inputs input[type="text"]')?.value;
    const normalized = postcode.trim().toUpperCase();
    
    if (!/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/.test(normalized)) {
      this.querySelector('.da-checker-result').dataset.result = 'regex';
      
      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });
      return;
    }
    if (!!this.postcodes.some(prefix => normalized.startsWith(prefix))) {
      this.querySelector('.da-checker-result').dataset.result = 'false';
      this.querySelector('.da-checker-result .da-result.da-eligible-false span').innerText = postcode;

      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });

      return;
    }

    this.querySelector('.da-checker-result').dataset.result = 'true';
    this.querySelectorAll('.da-inputs input').forEach(input => {
      input.disabled = false;
      if (input.value == 'yes') {
        input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
      }
    })
  }

  connectedCallback() {

    window.requestAnimationFrame(() => {

        // Guard: only attach listeners once per element instance
        if (this._initialized) return;
        this._initialized = true;

        const state = localStorage.getItem('deliver-and-assemble-state');
        if (state) {
            this.querySelector(`input[value="${state}"]`).checked = true;
        }

        if (this.classList.contains('da-cart')) {
          this.querySelector('.da-title-cart').addEventListener('click', () => {
            this.classList.toggle('da-expanded');
          });
        }
        const button = this.querySelector('.da-checker-inputs button');
        if (button) {
          button.addEventListener('click', () => {
            this.checkPostCode();
          });
        }

        const checkerInputs = this.querySelector('.da-checker-inputs');

        // Open checker when the postcode link span is clicked
        const checkerToggle = this.querySelector('.da-checker-text span');
        if (checkerToggle && checkerInputs) {
          checkerToggle.addEventListener('click', () => {
            checkerInputs.classList.toggle('mm-pdp-checker-open');
          });
        }

        // Main checkbox — show checker on check, hide on uncheck
        const daCheckbox = this.querySelector('[id^="mm-del-checkbox"]');
        if (daCheckbox && checkerInputs) {
          const syncChecker = () => {
            checkerInputs.classList.toggle('mm-pdp-checker-open', daCheckbox.checked);
            if (!daCheckbox.checked) {
              const resultEl = this.querySelector('.da-checker-result');
              if (resultEl) resultEl.dataset.result = '';
              const noRadio = this.querySelector('input[value="no"]');
              if (noRadio) noRadio.checked = true;
              localStorage.setItem('deliver-and-assemble-state', 'no');
              this.removeAllBuildProducts();
            }
          };
          // 'change' fires after state updates in all modern browsers
          daCheckbox.addEventListener('change', syncChecker);
          // 'click' + rAF as a belt-and-suspenders fallback
          daCheckbox.addEventListener('click', () => requestAnimationFrame(syncChecker));
        }

        this.querySelectorAll('input[type="radio"]').forEach(input => {
            input.addEventListener('change', (e) => {
                
                if (e.target.value == 'yes') {
                    this.addMissingBuildProducts();
                }
                if (e.target.value == 'no') {
                    this.removeAllBuildProducts();
                }

                localStorage.setItem('deliver-and-assemble-state', e.target.value);

                document.dispatchEvent(new CustomEvent('deliver-and-assemble:change', {
                    detail: {
                        value: e.target.value
                    }
                }));
            });
        })
    });

    document.addEventListener('deliver-and-assemble:change', (e) => {
        this.querySelector(`input[type="radio"][value="${e.detail.value}"]`).checked = true;
    });

    if (DeliverAndAssemble.mounted) return;

    DeliverAndAssemble.mounted = true;

    const onCartChange = async () => {
        await this.removeBuildProductsWithMissingMainProduct();

        const daCheckbox = this.querySelector('[id^="mm-del-checkbox"]');
        const radioYes = this.querySelector('input[value="yes"]:checked')?.value == 'yes';
        const optedIn = radioYes && (!daCheckbox || daCheckbox.checked);
        if (!optedIn) return;
        await this.makeSureBuildProductIsOne();
        if (!this._addingBuildProduct) {
          this.addMissingBuildProducts();
        }
    };
    document.addEventListener('myo:cart.change', onCartChange);
    document.addEventListener('rebuy:cart.change', onCartChange);
  }

  disconnectedCallback() {

  }
}

customElements.define("deliver-and-assemble", DeliverAndAssemble);
})();
/*** END: Deliver and Assemble ***/



// ============== Stat :  Discount dropdwan function ==============

document.addEventListener("click", function(e) {
  const trigger = e.target.closest(".rebuy-have-discount-code");
  if (!trigger) return;

  const container = document.querySelector(".rebuy-cart__discount-container");
  if (!container) return;

  trigger.classList.toggle("showDiscount");
  container.classList.toggle("showDiscount");
});

// ============== End :  Discount dropdwan function ==============



// ============== Stat :  Dilivery date function ==============

window.deliveryProducts = `MyoPro
MyoIce Elite
MyoFreeze
MyoFreeze & MyoChill
MyoIce Elite & MyoChill
MyoZone
MyoChill
MyoChill+
MyoChill Filter
MyoChill+ Filter
MyoSauna Infrared
MyoSauna Lux
MyoSauna Classic
MyoAir 2.0
MyoIce Pro
MyoLite`.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
window.deliveryMessages = `Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Royal Mail 48 hour delivery 
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Royal Mail 48 hour delivery
Royal Mail 48 hour delivery 
In stock. Delivered within 48 hours
Est. Delivery 2 - 3 weeks
Schedule delivery within 48 hours. Est delivery within 14 days.
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery
Order by 4pm for next work day delivery`.split(/\r?\n/).map(s => s.trim()).filter(Boolean);

(function(){

  function buildRules(){
    const rules = {};

    if (!window.deliveryProducts || !window.deliveryMessages) return rules;

    window.deliveryProducts.forEach((product, i) => {
      const name = product.trim().toLowerCase();
      const msg = window.deliveryMessages[i]?.trim();
      if (name && msg) {
        rules[name] = msg;
      }
    });

    return rules;
  }


  function updateCartDeliveryMessages() {
    const cartList = document.querySelector('ul[data-smartcart-items]');
    if (!cartList) return;

    const items = cartList.querySelectorAll('li');
    const deliveryRules = buildRules();

    items.forEach(item => {

      const titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
      if (!titleEl) return;

      const productTitle = titleEl.textContent.trim().toLowerCase();

      // remove old message if exists
      const existingMsg = item.querySelector('.custom-delivery-message');
      if (existingMsg) existingMsg.remove();

      // if no rule → skip
      if (!deliveryRules[productTitle]) return;

      // create message
      const messageEl = document.createElement('div');
      messageEl.className = 'custom-delivery-message';
      messageEl.textContent = deliveryRules[productTitle];

      const priceContainer = item.querySelector('.rebuy-cart__flyout-item-price');
      if (priceContainer) {
        priceContainer.appendChild(messageEl);
      }

    });
  }


  /* ---------- EVENTS ---------- */

  document.addEventListener('rebuy:cart.ready', updateCartDeliveryMessages);

  document.addEventListener('rebuy:cart.show', updateCartDeliveryMessages);

  document.addEventListener('rebuy:cart.add', () => {
    setTimeout(updateCartDeliveryMessages, 500);
  });

  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(updateCartDeliveryMessages, 500);
  });

})();


// ============== End :  Dilivery date function ==============